<div class="spinner-dialog-container">
  <app-custom-spinner></app-custom-spinner>
</div>
